import { CardsTratamiento } from "../../Components/Cards Tratamientos/CardsTratamientos";
import { Cards } from "../../Components/Cards planes/CardsPlanes";


function Tratamiento() {
  return (
    <div>
     
      <CardsTratamiento/>
      <Cards />
    </div>
  );
}
export default Tratamiento;
